import { render, staticRenderFns } from "./drawer-company-phone.vue?vue&type=template&id=0908674e&"
import script from "./drawer-company-phone.vue?vue&type=script&lang=js&"
export * from "./drawer-company-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports